module.exports = __webpack_public_path__ + "public/Icons/manage_promo_code.svg?f49d4e11";